var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "180",
        height: "180",
        viewBox: "0 0 180 180",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: { cx: "90", cy: "90", r: "85", fill: "#F8F9FA", opacity: "0.5" },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M130 50H50C43.3726 50 38 55.3726 38 62V102C38 108.627 43.3726 114 50 114H65L75 130L85 114H130C136.627 114 142 108.627 142 102V62C142 55.3726 136.627 50 130 50Z",
          fill: "#E8EBED",
          stroke: "#D0D7DE",
          "stroke-width": "2",
        },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: { cx: "125", cy: "45", r: "8", fill: "#5625cc", opacity: "0.2" },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: { cx: "135", cy: "40", r: "6", fill: "#5625cc", opacity: "0.3" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "55",
          y: "68",
          width: "50",
          height: "4",
          rx: "2",
          fill: "#C5CCD4",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "55",
          y: "80",
          width: "70",
          height: "4",
          rx: "2",
          fill: "#C5CCD4",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "55",
          y: "92",
          width: "45",
          height: "4",
          rx: "2",
          fill: "#C5CCD4",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { transform: "translate(75, 50)" } }, [
        _c("circle", {
          attrs: {
            cx: "30",
            cy: "30",
            r: "18",
            fill: "white",
            stroke: "#5625cc",
            "stroke-width": "3",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M43 43L52 52",
            stroke: "#5625cc",
            "stroke-width": "3",
            "stroke-linecap": "round",
          },
        }),
      ]),
      _vm._v(" "),
      _c("circle", {
        attrs: { cx: "25", cy: "70", r: "4", fill: "#5625cc", opacity: "0.15" },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: {
          cx: "155",
          cy: "90",
          r: "5",
          fill: "#5625cc",
          opacity: "0.15",
        },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: { cx: "30", cy: "120", r: "3", fill: "#5625cc", opacity: "0.2" },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: {
          cx: "150",
          cy: "125",
          r: "4",
          fill: "#5625cc",
          opacity: "0.2",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { transform: "translate(20, 135)" } }, [
        _c("circle", {
          attrs: { cx: "10", cy: "10", r: "8", fill: "#C5CCD4" },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M2 25C2 20 6 18 10 18C14 18 18 20 18 25",
            fill: "#C5CCD4",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }